module.exports = __webpack_public_path__ + "img/fortnightly-deliveries.89e381ba.png";